export default {"src":"/_next/static/media/fitment.b7b7aced.svg","height":640,"width":640};